/*
 * This file contains the floorplan grid card component.
 */

import clsx from "clsx";
import styles from "../floorplans.module.scss";
import { formatCurrency, getAvailabilityDate } from "../../../utils/util";
import FloorplanSpecialComponent from "./floorplanSpecialComponent";
import defaultImage from "../../../assets/images/no-image.png";
import { useState } from "react";
import VirtualTourPopup from "../virtualTourPopup";

export default function FloorplanGridCard({
  data,
  fpData,
  specials,
  contactLink,
  params,
  engrainFeeCalculator,
}) {
  // This function handles the image error event.
  // It prevents infinite loops in case the fallback also fails and sets the image source to the default image.
  const handleImageError = (e) => {
    e.target.onerror = null; // Prevent infinite loops in case the fallback also fails
    e.target.src = defaultImage;
    e.target.className = "noImage";
  };

  const [isVirtualTourOpen, setIsVirtualTourOpen] = useState(false);
  return (
    <div className={clsx(styles.FloorplanGridCard)}>
      <div className={styles.Availability}>
        {getAvailabilityDate(data?.min_availability_date, data?.status) !== "" ? (
          <>
            {parseInt(data?.available_unit_count) > 0 && (
              <span>
                Available{" "}
                {getAvailabilityDate(data?.min_availability_date, data?.status)}
              </span>
            )}
          </>
        ) : (
          <span className={styles.ComingSoon}>Coming Soon</span>
        )}
      </div>
      <div className={styles.FpImage}>
        <a
          href={`/floor-plans/${data?.floorplan_name}/${data?.floorplan_id}${
            params ? `/?${params}` : ""
          }`}
        >
          <img
            src={fpData?.floorplan_image || defaultImage}
            className={clsx(!fpData?.floorplan_image && "noImage")}
            alt="Floorplan"
            onError={handleImageError}
          />
        </a>
      </div>
      <div className={styles.CardFooter}>
        <div className={styles.specialsWrapper}>
          <FloorplanSpecialComponent
            typeListing={true}
            specials={specials}
            fpId={fpData?.floorplan_id}
          />
        </div>
        <div className={styles.NameWrapper}>
        <h3 className={styles.Name}>
          {data?.floorplan_name}
        </h3>
        <ul className={styles.Features}>
          <li>
            {data?.bed_count === "0" ? "Studio" : `${data?.bed_count} Bedroom`}
          </li>
          <li>{parseFloat(data?.bath_count)} Bath</li>
        </ul>
        </div>
  
        <p className={styles.PriceSpace}>
          {parseInt(data?.max_rent) > 0 ? (
            <>
              {engrainFeeCalculator?.enabled === "1" ? "Base Rent From" : "From"} <span>{formatCurrency(data?.min_rent)}{engrainFeeCalculator?.enabled === "1" ? "*" : ""}</span>
            </>
          ) : (
            <span>Call for pricing</span>
          )}
          <svg width="6" height="6" viewBox="0 0 6 6" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="3" cy="3" r="2" stroke="#AD8E6F"/>
          </svg>
         <span>{data?.min_sqft}</span> SQ.FT.
        </p>
        {data?.virtual_tour_url && (
          <div className={styles.VirtualTourBtn}>
            <button onClick={() => setIsVirtualTourOpen(true)}>
          Virtual Tour <svg xmlns="http://www.w3.org/2000/svg" width="18" height="12" viewBox="0 0 18 12" fill="none">
                <path d="M8.78662 0.121094C4.09462 0.121094 0.286621 2.01648 0.286621 4.35186C0.286621 6.24725 2.78562 7.84648 6.23662 8.38802V11.1211L9.63662 7.73648L6.23662 4.35186V6.66186C3.55912 6.18802 1.98662 5.05417 1.98662 4.35186C1.98662 3.45494 4.57062 1.8134 8.78662 1.8134C13.0026 1.8134 15.5866 3.45494 15.5866 4.35186C15.5866 4.96956 14.3456 5.95109 12.1866 6.49263V8.22725C15.1871 7.57571 17.2866 6.08648 17.2866 4.35186C17.2866 2.01648 13.4786 0.121094 8.78662 0.121094Z" fill="#AD8E6F" />
              </svg>
            </button>
          </div>
        )}
      
      
      {engrainFeeCalculator?.enabled === "1" && (
        <span className={styles.EngrainFeeCalculatorDisclaimer}>{engrainFeeCalculator?.short_disclaimer}</span>
      )}
      </div>



      {getAvailabilityDate(data?.min_availability_date, data?.status) !== "" ? (
        <div className={clsx(styles.BtnWrapper, "card-btn-wrapper")}>
          {parseInt(data?.max_rent) > 0 ? (
            <a
              href={data?.availability_url}
              target="_blank"
              rel="noreferrer"
              className={clsx(styles.Btn, styles.primary, "apply-now-btn")}
            >
              Apply Now
            </a>
          ) : (
            <a
              href={contactLink}
              className={clsx(styles.Btn, styles.primary)}
            >
              Get Notified
            </a>
          )}
          <a
            href={`/floor-plans/${data?.floorplan_name}/${data?.floorplan_id}${
              params ? `/?${params}` : ""
            }`}
            className={clsx(styles.Btn, styles.secondary)}
          >
            {`Availability (${data?.available_unit_count})`}
          </a>
        </div>
      ) : (
        <div className={styles.BtnWrapper}>
          <a href={contactLink} className={clsx(styles.Btn, styles.primary)}>
            Get Notified
          </a>
          <a
            href={`/floor-plans/${data?.floorplan_name}/${data?.floorplan_id}${
              params ? `/?${params}` : ""
            }`}
            className={clsx(
              styles.Btn,
              styles.secondary,
            )}
          >
            {`View Units`}
          </a>
        </div>
      )}
      <VirtualTourPopup
        isOpen={isVirtualTourOpen}
        onClose={() => setIsVirtualTourOpen(false)}
        virtualTourUrl={data?.virtual_tour_url}
      />

    </div>
  );
}
